// Tipos de programación
export const SCHEDULE_TYPE_ONCE = 1;
export const SCHEDULE_TYPE_RECURRENT = 2;
